import { createAction } from '@src/redux/helpers/createAction';
import { TOGGLE_MY_ACCOUNT } from './constants';

export const toggleMyAccount = (isOpen) => {
  return createAction({
    type: TOGGLE_MY_ACCOUNT,
    payload: isOpen,
  });
};
